// Card — 18px radius, 1px hairline border, 18px padding, bg-card.

import { cn } from '@/lib/utils'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function Card({ children, className, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-[18px] border border-border bg-card p-[18px]',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
